<template>
  <div class="date-range-picker">
    <flat-pickr
      v-model="dateValue"
      :config="config"
      :placeholder="options.placeholder || 'Select date range'"
      :disabled="options.disabled"
      class="form-control"
    />
  </div>
</template>

<script>
import 'flatpickr/dist/flatpickr.css';
import flatPickr from 'vue-flatpickr-component';

export default {
  name: 'DateRangePicker',
  components: {
    flatPickr,
  },
  props: {
    value: {
      type: Object,
      default: () => ({ start: null, end: null }),
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dateValue: null,
      config: {
        mode: 'range',
        dateFormat: 'Y-m-d',
        ...this.options.config,
      },
    };
  },
  watch: {
    value: {
      handler(val) {
        const start = val.start ? new Date(val.start) : null;
        const end = val.end ? new Date(val.end) : null;

        if (start && end) {
          this.dateValue = [start, end];
        } else if (start) {
          this.dateValue = [start];
        } else {
          this.dateValue = null;
        }
      },
      immediate: true,
      deep: true,
    },
    dateValue(val) {
      if (val && Array.isArray(val) && val.length > 0) {
        const range = {
          start: val[0] ? this.formatDate(val[0]) : null,
          end: val[1] ? this.formatDate(val[1]) : null,
        };
        this.$emit('input', range);
        this.$emit('change', range);
      } else {
        const range = { start: null, end: null };
        this.$emit('input', range);
        this.$emit('change', range);
      }
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.date-range-picker {
  width: 100%;
}
</style>
